import { TooltipContent } from '@anm/components/Tooltip';
import { SwitchWrapper } from '@anm/components/form/Switch';
import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { titleWithToglerStyles } from '../../Wrapper';

const SWITCH_HORIZONTAL_PADDING = 20;

const tooltipStyles = css`
  ${TooltipContent} {
    left: -239px;
    min-width: 287px;
  }
`;

export const PasswordSwitch = styled.div`
  ${titleWithToglerStyles};
  ${tooltipStyles};
`;

const wrapperAdaptive = media.tablet`
  padding: 0 20px;
`;

export const Wrapper = styled.div`
  margin-top: 31px;
  padding-bottom: 50px;
  ${PasswordSwitch} {
    margin-bottom: 20px;
  }
  ${SwitchWrapper} label {
    padding: 10px ${SWITCH_HORIZONTAL_PADDING}px;
    &:after {
      top: 12px;
      left: ${SWITCH_HORIZONTAL_PADDING + 2}px;
    }
  }
  input:checked + label:after {
    left: ${SWITCH_HORIZONTAL_PADDING + 26}px;
  }
  ${wrapperAdaptive};
`;
